import React from 'react'
import { RiDeleteBin6Line } from 'react-icons/ri'
import { useTranslation } from 'react-i18next';

const ConfirmDelete = ({ title, msg, onShow, setOnShow, loading = false, onDeleteHandler = () => {}, onCancelHandle = () => {} }) => {
    const [t] = useTranslation('global')

    if (!onShow) return null

    const onHide = () => {
        setOnShow(false);
        onCancelHandle();
    }

    return (
        <div className='fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center p-4 z-50'>
            <div className='bg-white rounded-lg max-w-md w-full'>
                <div className='p-6'>
                    <div className='flex items-center mb-4 gap-3'>
                        <div className='w-12 h-12 bg-red-100 rounded-full flex items-center justify-center'>
                            <RiDeleteBin6Line className='text-red-600' size={22} />
                        </div>
                        <h2 className='text-xl font-bold text-gray-800'>{title || t('common.confirmDelete')}</h2>
                    </div>
                    <p className='text-gray-600 mb-6'>{msg}</p>
                    <div className='flex gap-3'>
                        <button
                            type='button'
                            onClick={onHide}
                            disabled={loading}
                            className='flex-1 bg-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-400 transition-colors disabled:opacity-50'
                        >
                            {t('common.cancel')}
                        </button>
                        <button
                            type='button'
                            onClick={onDeleteHandler}
                            disabled={loading}
                            className='flex-1 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50'
                        >
                            {loading ? t('common.loading') : t('common.confirmDelete')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConfirmDelete
